import { Component, ViewEncapsulation, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';


import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-pdf-preview',
    templateUrl: './pdf-preview.component.html',
    styleUrls: ['./pdf-preview.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgxExtendedPdfViewerModule, TranslateModule]
})
export class PdfPreviewComponent {
    protected readonly bsModalRef = inject(BsModalRef);
    private _pending = false;

    title!: string;
    message!: string;
    fileContents!: string;

    closeBtn = true;
    closeText = 'signrequest.close';

    get pending(): boolean {
        return this._pending;
    }

    set pending(value: boolean) {
        this._pending = value;
    }

    closeAction() {
        this.bsModalRef.hide();
    }
}
